import _ from 'lodash'

import NitroPayAdController from './NitroPayAdController'
import PlaywireAdController from './PlaywireAdController'
import PubliftAdController from './PubliftAdController'

export const providers = [
    {
        id: 'pw',
        name: 'Playwire',
        privacyPolicyUrl: 'https://www.playwire.com/privacy-policy/',
        controller: PlaywireAdController,
    },
    {
        id: 'np',
        name: 'NitroPay',
        privacyPolicyUrl: 'https://www.nitropay.com/privacy/',
        controller: NitroPayAdController,
    },
    {
        id: 'pl',
        name: 'Publift',
        privacyPolicyUrl: 'https://www.publift.com/privacy-policy',
        controller: PubliftAdController,
    },
]

export const keyedProviders = _.keyBy(providers, 'id')

export const getCurrentProvider = () => {
    if (window.ramp) return keyedProviders.pw
    if (window.nitroAds) return keyedProviders.np
    if (window.fusetag) return keyedProviders.pl
    return null
}
